import React, { Component } from "react";

//Common Functions

import { BPMStatistics } from "../Common/BPMChart";
import { LoadScreen } from "../Common/LoadScreen";
import { DisplayType } from "../Common/Statistics/ChartObjects";
import { ChartType } from "../Common/Statistics/ChartObjects";
import * as pr from "../../common/PrimeComponents";
import * as format from "../../common/FormatFunctions";
import * as Log from "../../common/Feedback/Log";
import * as ChartHelper from "../Statistics/ChartExamples";

import { OperatorMetricViewModel } from "./OperatorMetricViewModel";
import {
  CrudlStatus,
  ToggleState,
  PageState
} from "../../common/config/AppConstants";

export class OperatorMetrics extends Component {
  constructor(props) {
    super(props);

    this.state = {
      operatorSelected: false,
      selectedOperator: {},
      imagePrefix: "/assets/layout/images/toolImages/",
      images: [
        "user-icon.png",
        "labour.png",
        "machine.png",
        "repair.png",
        "conveyor.png"
      ]
    };

    this.viewModel = new OperatorMetricViewModel();
    this.log = Log;
  }

  componentDidMount = async () => {
    this.initialDataRender();
    this.interval = setInterval(() => this.refresh(), 2000);
  };

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  componentDidCatch = (error, info) => {
    console.log("This went in here");

    //COMPONENT ISSUE CHECK IF THIS ERROR HANDLING IS CORRECT
    this.setError(false, "componentDidCatch", error);
  };
  updateState = (key, value) => {
    try {
      this.setState({ [key]: value });
    } catch (error) {
      this.setError(false, "updateState", error);
    }
  };

  initialDataRender = async () => {
    this.setViewModel();
    await this.setPageData();
  };

  setError = (critical, methodName, error) => {
    this.log.error(error.message);
    if (critical) {
      this.setCriticalError();
    } else {
      this.setStandardError();
    }
    this.viewModel.createException(error, this.state.pageName, methodName);
  };
  setStandardError = () => {
    //MORE CAN BE ADDED HERE AS APPROPRIATE
    this.showError("Product");
    this.setState({ pageState: PageState.IDLE });
  };
  setCriticalError = () => {
    //SET ERROR STATE OF PAGE
    this.setState({ pageState: PageState.ERROR });
  };
  menuState = crudlStatus => {
    try {
      this.setState({
        menuState: pr.getBreadcrumbMenuState(
          crudlStatus,
          "Operator",
          "#/Operators"
        )
      });
    } catch (error) {
      this.setError(false, "menuState", error);
    }
  };
  setViewModel = () => {
    try {
      this.viewModel.updateState = this.updateState;
      this.viewModel.showError = this.showError;
      this.viewModel.showSuccess = this.showSuccess;
      this.viewModel.showEmpty = this.showEmpty;
    } catch (error) {
      this.setError(false, "setViewModel", error);
    }
  };

  setPageData = async () => {
    try {
      this.setState({ pageState: PageState.LOADING });

      this.menuState(CrudlStatus.LIST);

      // SPECIFIC API CALLS GO HERE
      await this.viewModel.getUsers();

      //COMPONENT INFORMATION

      this.setState({
        pageState: PageState.IDLE
      });
    } catch (error) {
      this.setError(true, "setPageData", error);
    }
  };
  showError = (display, crudlStatus) => {
    try {
      this.feedback.showError(this.growl, display, crudlStatus);
    } catch (error) {
      this.setError(false, "showError", error);
    }
  };
  showSuccess = (display, crudlStatus) => {
    try {
      this.feedback.showSuccess(this.growl, display, crudlStatus);
    } catch (error) {
      this.setError(false, "showSuccess", error);
    }
  };
  showEmpty = display => {
    try {
      this.feedback.showEmpty(this.growl, display);
    } catch (error) {
      this.setError(false, "showEmpty", error);
    }
  };
  refresh = async () => {
    await this.viewModel.getUsers();
  };
  render() {
    return (
      <React.Fragment>
        <div className="ui-g-12">
          <pr.BreadCrumb
            model={this.state.menuState}
            home={pr.getBreadcrumbMenuHome()}
            style={{
              backgroundColor: "lightgrey",
              color: "black"
            }}
          />
        </div>
        <div className="ui-g-12">
          <div className="ui-g-12 ui-md-6 ui-lg-3">
            <div className="content-section">
              <div className="feature-intro">
                <h1>{"Operators"}</h1>
                <p>{"Specific Operator Statistics"}</p>
              </div>
            </div>
          </div>
        </div>
        {this.state.pageState === PageState.LOADING && <LoadScreen />}
        {this.state.pageState !== PageState.LOADING && (
          <React.Fragment>
            {this.state.operatorSelected === false && (
              <div className="ui-g-12">{this.renderOperatorCards()}</div>
            )}
            {this.state.operatorSelected === true && (
              <div className="ui-g-12">{this.renderIndividualOperator()}</div>
            )}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }

  renderOperatorCards = () => {
    var componentArray = [];
    var index = 0;

    if (format.isNotNull(this.state.userList)) {
      this.state.userList.forEach(element => {
        var value =
          Math.floor(Math.random() * (Math.floor(83) - Math.ceil(76) + 1)) +
          Math.floor(76);

        console.log(value);
        componentArray[index] = (
          <div
            className="ui-g-3 card ui-md-3 ui-lg-3"
            onClick={() => {
              this.setState({
                selectedOperator: element,
                operatorSelected: true
              });
            }}
          >
            <div className="ui-g-12" style={{ float: "middle" }}>
              <div className="ui-g-2">
                <img
                  src={this.state.imagePrefix + this.state.images[0]}
                  style={{
                    width: "100%",
                    height: "100%"
                  }}
                  alt=""
                />
              </div>
              <div className="ui-g-8">
                <center>
                  <h2>{element.email}</h2>
                </center>
              </div>
              <div className="ui-g-2"></div>
            </div>
            <div className="ui-g-12">
              {/* <div className="ui-g-2"></div>
            <div className="ui-g-2"></div> */}
            </div>

            <div className="ui-g-12">
              <div className="ui-g-3"></div>
              <div className="ui-g-6">
                {this.getChart(
                  DisplayType.CHART,
                  ChartType.GAUGE,
                  this.renderGuageData(value),
                  ChartHelper.renderGuageOptions()
                )}
              </div>
            </div>
          </div>
        );
        index++;
      });
    }
    return componentArray;
  };

  renderIndividualOperator = () => {
    return (
      <React.Fragment>
        <div className="ui-g-12 card ui-md-12 ui-lg-12">
          <pr.Button
            icon="pi pi-arrow-left"
            className="p-button-danger"
            style={{ marginRight: ".25em", float: "left" }}
            onClick={() => {
              this.setState({ operatorSelected: false, selectedOperator: {} });
            }}
          />
          <center>
            <h3>{this.state.selectedOperator.email}</h3>
          </center>
          <div className="ui-g-12">
            <div className="ui-g-6">
              <center>
                {this.getChart(
                  DisplayType.CHART,
                  ChartType.GAUGE,
                  this.renderGuageData(80),
                  ChartHelper.renderGuageOptions()
                )}
              </center>
            </div>
            {/* </div>
          <div className="ui-g-12">
            <div className="ui-g-3"> </div>
            <div className="ui-g-6">
              <div className="ui-g-2"></div> */}
            <div className="ui-g-6">
              {this.getChart(
                DisplayType.CHART,
                ChartType.GAUGE,
                this.renderGuageDataExpanded(),
                ChartHelper.renderGuageOptions()
              )}
            </div>
          </div>
        </div>
        {/* </div> */}
      </React.Fragment>
    );
  };

  getChart = (displayType, chartType, chartData, chartOptions) => {
    return (
      <BPMStatistics
        displayType={displayType}
        chartType={chartType}
        chartData={chartData}
        chartOptions={chartOptions}
      />
    );
  };
  renderGuageData = value => {
    var chartDataBean = {};

    chartDataBean.rows = [];
    chartDataBean.columns = [];

    chartDataBean.columns = [
      { label: "Label", type: "string", id: null },
      { label: "Value", type: "number", id: null }
    ];

    chartDataBean.rows.push(["Performance", value]);
    // chartDataBean.rows.push(["CPU", 55]);
    // chartDataBean.rows.push(["Network", 1]);

    console.log(value);
    return chartDataBean;
  };

  renderGuageDataExpanded = () => {
    var chartDataBean = {};

    chartDataBean.rows = [];
    chartDataBean.columns = [];

    chartDataBean.columns = [
      { label: "Label", type: "string", id: null },
      { label: "Value", type: "number", id: null }
    ];
    chartDataBean.rows.push(["Productivity", 80]);
    chartDataBean.rows.push(["Efficency", 55]);
    chartDataBean.rows.push(["Availability", 1]);

    return chartDataBean;
  };
}



// WEBPACK FOOTER //
// ./src/components/Operator/OperatorMetrics.js